import { verifyUser, sendPasswordResetEmail } from "../../api";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import axios from "axios";
import logo from "../../Resources/Transparent_Logo.png";
import React from "react";
import "./login.css";

export function LoginYt() {
  const navigate = useNavigate();
  const location = useLocation();

  const [user, setUser] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [forgotPassword, setForgotPassword] = useState(false);
  const [resetEmailSent, setResetEmailSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  function handleChange(e) {
    setUser({ ...user, [e.target.name]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    const redirectParam = new URLSearchParams(location.search).get("redirect");
    const safeRedirect =
      redirectParam && redirectParam.startsWith("/") ? redirectParam : "/home";

    if (forgotPassword) {
      if (!user.email) {
        setError("Please enter your email address.");
        setIsLoading(false);
        return;
      }
      try {
        await sendPasswordResetEmail(user.email);
        setResetEmailSent(true);
        setError("");
      } catch (err) {
        console.error("Error during password reset request:", err);
        setError("An error occurred. Please try again later.");
        setResetEmailSent(false);
      } finally {
        setIsLoading(false);
      }
      return;
    }

    try {
      const result = await verifyUser(user);
      if (!result?.success || !result?.token) {
        setError(result?.message || "Invalid credentials. Please try again.");
        setIsLoading(false);
        return;
      }
      sessionStorage.setItem("user", result.token);
      axios.defaults.headers.common["authorization"] = `Bearer ${result.token}`;
      navigate(safeRedirect, { replace: true });
    } catch (err) {
      console.error("Error during login:", err);
      setError("An error occurred. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  }

  function toggleForgotPassword() {
    setForgotPassword(!forgotPassword);
    setError("");
    setResetEmailSent(false);
  }

  return (
    <div className="login-page">
      <div className="login-shell">
        {/* Brand panel — logo only */}
        <aside className="login-brand" aria-hidden="false">
          <div className="login-brand-inner">
            <img src={logo} alt="PractoSync" className="login-brand-logo" />
          </div>
          <div className="login-brand-footer">
            &copy; {new Date().getFullYear()} PractoSync
          </div>
        </aside>

        {/* Form panel */}
        <main className="login-form-panel">
          <div className="login-card">
            <img src={logo} alt="PractoSync" className="login-card-logo" />

            {resetEmailSent ? (
              <div className="login-success">
                <div className="login-success-icon">
                  <i className="fa-light fa-envelope-circle-check" />
                </div>
                <h2 className="login-heading">Check your inbox</h2>
                <p className="login-sub">
                  If an account exists for that email, a password reset link is on its way.
                </p>
                <Button
                  type="button"
                  className="login-submit"
                  onClick={toggleForgotPassword}
                >
                  Back to sign in
                </Button>
              </div>
            ) : (
              <Form onSubmit={handleSubmit} noValidate>
                <h2 className="login-heading">
                  {forgotPassword ? "Reset your password" : "Welcome back"}
                </h2>
                <p className="login-sub">
                  {forgotPassword
                    ? "Enter your account email and we'll send you a reset link."
                    : "Sign in to your PractoSync account."}
                </p>

                {error && (
                  <div className="login-alert" role="alert">
                    <i className="fa-light fa-circle-exclamation me-2" />
                    {error}
                  </div>
                )}

                <Form.Group className="login-field" controlId="loginEmail">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="you@practice.co.za"
                    autoComplete="email"
                    onChange={handleChange}
                    name="email"
                    value={user.email}
                    required
                  />
                </Form.Group>

                {!forgotPassword && (
                  <Form.Group className="login-field" controlId="loginPassword">
                    <div className="login-field-row">
                      <Form.Label>Password</Form.Label>
                      <button
                        type="button"
                        className="login-link"
                        onClick={toggleForgotPassword}
                      >
                        Forgot password?
                      </button>
                    </div>
                    <div className="login-password-wrap">
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter your password"
                        autoComplete="current-password"
                        onChange={handleChange}
                        name="password"
                        value={user.password}
                        required
                      />
                      <button
                        type="button"
                        className="login-password-toggle"
                        onClick={() => setShowPassword((s) => !s)}
                        aria-label={showPassword ? "Hide password" : "Show password"}
                        tabIndex={-1}
                      >
                        <i className={`fa-light ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
                      </button>
                    </div>
                  </Form.Group>
                )}

                <Button
                  type="submit"
                  className="login-submit"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      />
                      {forgotPassword ? "Sending…" : "Signing in…"}
                    </>
                  ) : forgotPassword ? (
                    "Send reset link"
                  ) : (
                    "Sign in"
                  )}
                </Button>

                {forgotPassword && (
                  <button
                    type="button"
                    className="login-back"
                    onClick={toggleForgotPassword}
                  >
                    <i className="fa-light fa-arrow-left me-2" />
                    Back to sign in
                  </button>
                )}
              </Form>
            )}
          </div>

          <div className="login-mobile-footer">
            &copy; {new Date().getFullYear()} PractoSync
          </div>
        </main>
      </div>
    </div>
  );
}
